/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ChatSummary, ChatSummary$inboundSchema } from "./chatsummary.js";

/**
 * Result of searching chat session summaries
 */
export type SearchChatsResult = {
  /**
   * List of chat session summaries
   */
  chats: Array<ChatSummary>;
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const SearchChatsResult$inboundSchema: z.ZodMiniType<
  SearchChatsResult,
  unknown
> = z.pipe(
  z.object({
    chats: z.array(ChatSummary$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function searchChatsResultFromJSON(
  jsonString: string,
): SafeParseResult<SearchChatsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchChatsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchChatsResult' from JSON`,
  );
}
